<template>
  <div class="CustomsDetail_vue main-wrapper m-0 p-0 mt-3 font-jumperlight container-fluid">
    <div class="mx-3">
      <div class="font-jumper">
        <b-row>
          <b-col class="col-12 col-md-6 pt-4">
            <div class="inputLabel">Előnézet</div>

            <div v-if="thumbnail">
              <div class="thumbnailContainer">
                <img
                    :src="getImgFromByteArray(thumbnail.content)"
                />
              </div>
              <div class="thumbnailFunctions d-flex justify-content-between">
                <b-form-input v-model="currentFileName" :disabled="true"/>
                <b-button variant="secondary" class="circleBtn ml-2" @click="prevPage" v-if="thumbnail.numberOfPages > 1">
                  <i class="fa fal fa-chevron-left"></i>
                </b-button>
                <b-button variant="secondary" class="circleBtn ml-2" @click="nextPage" v-if="thumbnail.numberOfPages > 1">
                  <i class="fa fal fa-chevron-right"></i>
                </b-button>
                <b-button variant="secondary" class="circleBtn ml-2" @click="downloadFile">
                  <i class="fa fal fa-download"></i>
                </b-button>
              </div>
            </div>

            <div v-else-if="!thumbnail && knownDocumentId" class="thumbnailContainer d-flex align-items-center justify-content-center">
              <div class="text-center text-muted">
                <p>Előnézet betöltése...</p>
              </div>
            </div>

          </b-col>
          <b-col class="col-12 col-md-6 pt-4">

            <div class="mt-4">
              <InvoiceSearchDropdown
                  :customs-id="details.id"
                  :initial-selected-invoice="details.attachedInvoiceDigest"
                  @invoice-selected="onInvoiceSelected"
                  @invoice-cleared="onInvoiceCleared"
              />
            </div>

            <div class="inputLabel">Határozat azonosító</div>
            <b-form-input v-model="details.resolutionId" :disabled="true"/>

            <div class="inputLabel">Kézbesítés dátuma</div>
            <b-form-input v-model="formattedDeliveryDate" :disabled="true"/>

            <div class="inputLabel">Teljesítés dátuma</div>
            <b-form-input v-model="formattedTaxpointDate" :disabled="true"/>

            <div class="inputLabel">Behozatali vám összesen</div>
            <b-form-input v-model="formattedBehozataliVam" :disabled="true"/>

            <div class="inputLabel">Import ÁFA összesen</div>
            <b-form-input v-model="formattedTotalVat" :disabled="true"/>

          </b-col>
        </b-row>
      </div>
    </div>
  </div>
</template>

<script>
import Api from "api-client";
import InvoiceSearchDropdown from "@/views/app/costs/InvoiceSearchDropdown.vue";

export default {
  name: "CustomsDetail",

  components: {
    InvoiceSearchDropdown
  },

  props: {
    details: {
      required: true,
      type: Object,
    },
    selectedFile: {
      required: true,
      type: Object,
    }
  },

  data() {
    return {
      thumbnail: {},
      currentPage: 0,
      selectedInvoice: null,
    };
  },

  computed: {
    knownDocumentId() {
      return this.selectedFile?.knownDocumentId || null;
    },

    currentFileName() {
      return this.selectedFile?.fileName || '';
    },

    formattedDeliveryDate() {
      if (!this.details.deliveryDate) return '';
      const date = new Date(this.details.deliveryDate);
      return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
    },

    formattedTaxpointDate() {
      if (!this.details.taxpointDate) return '';
      const date = new Date(this.details.taxpointDate);
      return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
    },

    formattedBehozataliVam() {
      if (this.details.behozataliVamOsszesen === null || this.details.behozataliVamOsszesen === undefined) return '';
      return this.formatCurrency(this.details.behozataliVamOsszesen) + ' Ft';
    },

    formattedTotalVat() {
      if (this.details.totalVatAmount === null || this.details.totalVatAmount === undefined) return '';
      return this.formatCurrency(this.details.totalVatAmount) + ' Ft';
    },
  },

  watch: {
    selectedFile: {
      handler(newFile) {
        if (newFile?.knownDocumentId) {
          this.currentPage = 0;
          this.thumbnail = {};
          this.getDocumentThumbnail();
        }
      },
      immediate: true,
    }
  },

  methods: {
    onInvoiceSelected(invoice) {
      this.selectedInvoice = invoice;
      console.log("Selected invoice:", invoice);
    },

    onInvoiceCleared(invoice) {
      this.selectedInvoice = null;
      console.log("Cleared invoice:", invoice);
    },

    formatCurrency(value) {
      return new Intl.NumberFormat('hu-HU').format(value);
    },

    getImgFromByteArray(encoded) {
      return "data:image/png;base64," + encoded;
    },

    getDocumentThumbnail() {
      if (!this.knownDocumentId) return;

      Api.getDocumentThumbnail(this.knownDocumentId, this.currentPage)
          .then(response => {
            this.thumbnail = response.data;
          })
          .catch(error => {
            console.error("Error fetching thumbnail:", error);
          });
    },

    nextPage() {
      if (this.currentPage < this.thumbnail.numberOfPages - 1) {
        this.currentPage += 1;
        this.getDocumentThumbnail();
      }
    },

    prevPage() {
      if (this.currentPage > 0) {
        this.currentPage -= 1;
        this.getDocumentThumbnail();
      }
    },

    downloadFile() {
      if (!this.knownDocumentId) return;

      Api.getDocumentThumbnail(this.knownDocumentId, this.currentPage, true)
          .then(response => {
            const byteCharacters = atob(response.data.content);
            const byteNumbers = new Array(byteCharacters.length);
            for (let i = 0; i < byteCharacters.length; i++) {
              byteNumbers[i] = byteCharacters.charCodeAt(i);
            }
            const byteArray = new Uint8Array(byteNumbers);
            const blob = new Blob([byteArray], { type: response.data.contentType || 'application/octet-stream' });
            const link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            link.download = this.currentFileName || 'document.pdf';
            link.style.display = 'none';
            document.body.appendChild(link);
            link.click();
            setTimeout(() => {
              document.body.removeChild(link);
              window.URL.revokeObjectURL(link.href);
            }, 100);
          })
          .catch(error => {
            console.error("Error downloading document:", error);
            this.$toast.error({
              title: "Hiba történt",
              message: "A fájl letöltése nem sikerült"
            });
          });
    },
  },
}
</script>

<style scoped>
.main-wrapper {
  background-color: white;
  padding: 15px;
  border-radius: 5px;
}

.btn-link {
  color: #333;
  text-decoration: none;
}

.btn-link:hover {
  color: #252734;
}

.inputLabel {
  margin-left: 16px;
  margin-bottom: 8px;
  margin-top: 16px;
}

.thumbnailContainer {
  width: 100%;
  height: 705px;
  overflow: hidden;
  border-radius: 32px;
  box-shadow: 0px 20px 30px 0px #0000001A;
  background-color: white;
}

.thumbnailContainer img {
  width: 100%;
  height: auto;
  max-height: 100%;
  object-fit: contain;
}

.thumbnailFunctions {
  position: absolute;
  width: 90%;
  margin-top: -75px !important;
  margin-left: 10px;
  padding: 10px;
  background-color: white;
  border: 1px solid #AEBFC7;
  border-radius: 32px;
  box-shadow: 0px 20px 30px 0px #0000001A;
}

.thumbnailFunctions input {
  margin-bottom: 0px !important;
}

.circleBtn {
  width: 60px !important;
  height: 40px !important;
  text-align: center !important;
  font-size: 14px !important;
  padding: 0px !important;
  border: 1px solid #AEBFC7 !important;
}
</style>
